/**
 * @typedef {Object} BookingClientGroupViewModelType
 * @property {number} id - Unique identifier
 * @property {string} name - The name of the client group
 */

/**
 * @class
 */
export default class BookingClientGroupViewModel {
  /**
   * Create a new BookingClientGroupViewModel.
   * @param {...BookingClientGroupViewModelType} params
   */
  constructor(params) {
    this.id = params.id
    this.name = params.name
  }
}
